var render = function () {
  var _vm$deliveryServicesP;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "vehicle text-left"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-6"
  }, [_vm._v("Pilih Pickup Layanan")]), _vm._l((_vm$deliveryServicesP = _vm.deliveryServicesPickup[0]) === null || _vm$deliveryServicesP === void 0 ? void 0 : _vm$deliveryServicesP.packages, function (pickup) {
    var _vm$selectedPickup;

    return _c('div', {
      key: pickup.id,
      staticClass: "mb-4 last:mb-6 cursor-pointer border rounded-md px-3 py-2 flex justify-between items-center",
      class: {
        'bg-primary-100 border border-primary-500': ((_vm$selectedPickup = _vm.selectedPickup) === null || _vm$selectedPickup === void 0 ? void 0 : _vm$selectedPickup.id) === pickup.id
      },
      on: {
        "click": function click($event) {
          return _vm.selectPickup(pickup);
        }
      }
    }, [_c('div', [_c('p', {
      staticClass: "text-sm font-medium"
    }, [_vm._v(_vm._s(pickup === null || pickup === void 0 ? void 0 : pickup.name))]), _c('p', {
      staticClass: "text-xs"
    }, [_vm._v("Berat barang " + _vm._s(pickup === null || pickup === void 0 ? void 0 : pickup.minimum_weight) + " - " + _vm._s(pickup === null || pickup === void 0 ? void 0 : pickup.maximum_weight) + " kg")])]), _c('div', [_c('p', {
      staticClass: "text-sm font-medium text-right"
    }, [_vm._v(_vm._s(_vm._f("currencyFormat")(pickup === null || pickup === void 0 ? void 0 : pickup.shipment_cost)))]), _c('p', {
      staticClass: "text-xs text-right"
    }, [_vm._v(_vm._s(pickup === null || pickup === void 0 ? void 0 : pickup.est_delivery_time_range_min) + " - " + _vm._s(pickup === null || pickup === void 0 ? void 0 : pickup.est_delivery_time_range_max))])])]);
  }), _c('div', {
    staticClass: "flex justify-end items-center gap-4 mt-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Cancel",
      "type": "secondary"
    },
    on: {
      "action": function action($event) {
        return _vm.closeModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Apply",
      "type": "primary",
      "disabled": !_vm.selectedPickup
    },
    on: {
      "action": function action($event) {
        return _vm.apply();
      }
    }
  })], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }